import type { Load } from 'api';
import { formatDateTime } from 'date';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemSecondaryAction, ListItemText } from 'ui';

export const LoadListItem = ({ load, children }: { load: Load; children?: ReactNode }) => {
  return (
    <ListItem to={`/ground-control/inspections/loads?loadId=${load.id}`} component={Link}>
      <ListItemText
        primary={load.name}
        secondary={load.estimated_collection_time ? formatDateTime(load.estimated_collection_time) : null}
      />
      {children ? <ListItemSecondaryAction>{children}</ListItemSecondaryAction> : null}
    </ListItem>
  );
};
